module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('footer', [_h('div', ["\n  © 2016 とだ整体\n  "])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3aa5f1ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Footbar.vue
// module id = 432
// module chunks = 0